export default {
  feedback: {
    success: 'App Mobile salvata con successo',
    error: 'Salvataggio App Mobile fallito',
  },
};
